export const ringSizes = [50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60]
